<template>
  <div class="layout">

    <common-header />

    <router-view class="body"></router-view>

    <common-footer />

  </div>
</template>

<script>
import CommonHeader from './Header.vue'
import CommonFooter from './Footer.vue'

export default {
  components: { CommonHeader, CommonFooter }
}
</script>

<style lang="scss" scoped>
.layout {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  position: relative;

  header {
    height: 100px;
    margin: 0 auto;
  }
  .body {
    padding: 10px;
  }
  footer {
    position: absolute;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Layout.vue